import { AgentKernelRequest } from "@/types/app/agent";

const USER_INPUT_TOOL = {
  type: "inline" as const,
  on_agent_call: "continue" as const,
  json_schema: {
    name: "user_input",
    description:
      "This tool is used to get user input. Call it whenever you need to ask the user for feedback or ask a question.",
    parameters: {
      type: "object",
      properties: {
        prompt: {
          type: "string",
          description: "The prompt to ask the user.",
        },
      },
      additionalProperties: false,
      required: ["prompt"],
    },
    strict: true,
  },
};

const STOP_TOOL = {
  type: "inline" as const,
  on_agent_call: "stop" as const,
  json_schema: {
    name: "stop",
    description: "This tool is used to exit. Call it when you have finished your task.",
    parameters: {
      type: "object",
      properties: {},
      additionalProperties: false,
      required: [],
    },
    strict: true,
  },
};

export const DEFAULT_AGENT: AgentKernelRequest = {
  model: "gpt-4o",
  endpoint: "chat",
  template: [
    {
      role: "system",
      content: "You are a helpful agent.",
    },
  ],
  provider: "openai",
  tools: [USER_INPUT_TOOL, STOP_TOOL],
};
